module.exports = __webpack_public_path__ + "img/jkgl1.1f0dd094.png";